"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdentityProperty = void 0;
var react_1 = __importDefault(require("react"));
var prism_icons_1 = require("@octanner/prism-icons");
var Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
var Chip_1 = __importDefault(require("../Chip"));
var TextField_1 = __importDefault(require("../TextField"));
var SearchOptionCard_1 = __importDefault(require("./SearchOptionCard"));
var colors_1 = require("../ThemeProvider/colors");
var prism_utilities_1 = require("@octanner/prism-utilities");
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("./styles");
var DEFAULT_OPTIONS = [];
// avoid passing down onchange prop for pagefilter
var Search = function (_a) {
    var _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, error = _a.error, freeSolo = _a.freeSolo, helperText = _a.helperText, label = _a.label, loading = _a.loading, multiple = _a.multiple, options = _a.options, placeholder = _a.placeholder, inputDataTestId = _a.inputDataTestId, disabled = _a.disabled, value = _a.value, clearIcon = _a.clearIcon, onChange = _a.onChange, props = __rest(_a, ["autoFocus", "required", "error", "freeSolo", "helperText", "label", "loading", "multiple", "options", "placeholder", "inputDataTestId", "disabled", "value", "clearIcon", "onChange"]);
    return (react_1.default.createElement(Autocomplete_1.default, __assign({ onChange: onChange, clearIcon: clearIcon !== null && clearIcon !== void 0 ? clearIcon : (react_1.default.createElement(prism_icons_1.Close, { tabIndex: 0, sx: (props.size && { color: colors_1.tannerGray['600'] }) || {} })), filterOptions: function (options) { return options; }, freeSolo: freeSolo !== null && freeSolo !== void 0 ? freeSolo : true, getOptionLabel: multiple ? undefined : (0, exports.getIdentityProperty)('getOptionLabel'), sx: (props.size === 'small' && {
            '.MuiAutocomplete-clearIndicator': {
                '&:hover': {
                    backgroundColor: colors_1.tannerGray['200'],
                },
            },
        }) ||
            {}, multiple: multiple !== null && multiple !== void 0 ? multiple : true, options: options !== null && options !== void 0 ? options : DEFAULT_OPTIONS, disabled: disabled, renderTags: function (options, getTagProps) {
            return options.map(function (option, index) { return (react_1.default.createElement(Chip_1.default, __assign({ label: (0, exports.getIdentityProperty)('renderTags')(option) }, getTagProps({ index: index })))); });
        }, renderOption: function (props, option) { return (react_1.default.createElement(SearchOptionCard_1.default, __assign({}, props, { avatarUrl: (0, exports.getIdentityProperty)('renderOption')(option, 'avatarUrl'), showAvatar: true, subTitle: (0, exports.getIdentityProperty)('renderOption')(option, 'buName'), title: (0, exports.getIdentityProperty)('renderOption')(option) }))); }, PaperComponent: styles_1.CustomPaper, renderInput: function (props) { return (react_1.default.createElement(TextField_1.default, __assign({}, props, { 
            // eslint-disable-next-line
            autoFocus: autoFocus, error: error, helperText: helperText, label: label, placeholder: Array.isArray(value) && Boolean(value === null || value === void 0 ? void 0 : value.length) ? '' : placeholder, variant: "outlined", required: required, inputProps: __assign(__assign({}, props.inputProps), { 'data-testid': inputDataTestId, className: (0, classnames_1.default)('prism-search', props.inputProps.className), onKeyDown: function (e) {
                    if (e.key === 'Enter' &&
                        ((options === null || options === void 0 ? void 0 : options.length) === 0 || loading || !onChange)) {
                        e.stopPropagation();
                    }
                } }), InputProps: (0, styles_1.getSearchInputStyles)(disabled, props, loading) }))); }, value: value }, props)));
};
exports.default = Search;
var getIdentityProperty = function (type) { return function (option, value) {
    var _a, _b;
    if (isIdentity(option)) {
        switch (value) {
            case 'avatarUrl':
                return ((_a = option.profile) === null || _a === void 0 ? void 0 : _a.avatar) || '';
            case 'buName':
                return ((_b = option.businessUnit) === null || _b === void 0 ? void 0 : _b.buName) || '';
            default:
                return (0, prism_utilities_1.getFullName)(option);
        }
    }
    return "Use default Identity type or implement \"".concat(type, "\"");
}; };
exports.getIdentityProperty = getIdentityProperty;
var isIdentity = function (option) {
    return option.firstName !== undefined;
};
//# sourceMappingURL=Search.js.map